import ConfirmationModal from "~/common/components/ConfirmationModal";
import { LinkButton } from "~/common/components/Link";
import { requestConfirmation } from "~/common/utils/ModalService";
import { type WishlistModel } from "~/features/wishlist/types/model";
import { useDispatch } from "react-redux";
import { removeSelectedWishlistThunk } from "~/features/wishlist/redux/wishlistSlice";
import { useTranslation } from "react-i18next";
import DeleteIcon from "@mui/icons-material/Delete";

interface DeleteWishlistButton {
  wishlist: WishlistModel;
}
export const DeleteWishlistButton = ({ wishlist }: DeleteWishlistButton) => {
  const { t } = useTranslation();
  const label = t("wishlistPage.deleteWishlist", { name: wishlist.name });

  const dispatch = useDispatch();

  const onClick = async () => {
    const confirmation = await requestConfirmation(({ onConfirm, onCancel }) => (
      <ConfirmationModal
        label={label}
        okLabel={t("common.yes")}
        cancelLabel={t("common.no")}
        onCancel={onCancel}
        onOk={onConfirm}
      />
    ));
    if (confirmation) {
      dispatch(removeSelectedWishlistThunk());
    }
  };

  return (
    <LinkButton onClick={onClick} data-test-id={"btn-delete-wishlist"} iconBefore={<DeleteIcon  />}>
      {t("wishlistPage.button.deleteProduct")}
    </LinkButton>
  );
};
